export const DISMISSAL_COUNT_KEY = 'dismissed-count';
export const DISMISS_UNTIL_KEY = 'dismiss-until';
export const UNASSIGNED_FILTER_NUDGE_STORAGE_KEY = 'unassigned-filter-spotlight';
